import { Card, CardProps, theme } from 'antd';
import { ReactNode } from 'react';

interface CardContainerProps extends CardProps {
    children: ReactNode;
    width?: string | number;
}

export default function CardContainer({ children, width = 450, style, ...rest }: CardContainerProps) {
    const {
        token: { boxShadow }
    } = theme.useToken();

    return (
        <Card title="" bordered={false} style={{ width, boxShadow, ...style }} {...rest}>
            {children}
        </Card>
    );
}
